import React from 'react';
import { DropdownMenu } from 'components/DropdownMenu/DropdownMenu';
import { useRematchSelector } from 'models/rematchStore';
import { constructNewPathname, getLocation } from 'common/state.helper';
import { useNavigate } from 'react-router-dom';
import { Logger } from 'common/logger';

const toDropdownItem = (screen) => ({
    value: screen,
    text: screen.toUpperCase(),
    key: screen,
});

export const ScreenSelectView = () => {
    const navigate = useNavigate();

    const { allowedScreens, selectedPark, selectedScreen } = useRematchSelector((state) => ({
        allowedScreens: state.account.allowedScreens,
        selectedPark: state.appData.selectedPark.toLowerCase(),
        selectedScreen: state.appData.selectedScreen,
    }));

    const handleChange = (screen) => () => {
        const value = screen.value;
        const { pathName } = getLocation();
        Logger.info(`Changing screen to ${value}`);
        navigate(constructNewPathname(selectedPark, value, pathName));
    };

    const screens = allowedScreens[selectedPark] || [];

    if (!(selectedScreen && screens.length)) {
        return null;
    }

    return (
        <DropdownMenu
            label="Screen"
            handleChange={handleChange}
            selectedItem={{ text: selectedScreen }}
            items={screens.map(toDropdownItem)}
        />
    );
};
